require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faHeart as fasHeart,
    faBell as fasBell,
    faCheck as fasCheck,
    faCheckSquare as fasCheckSquare,
    faPlus as fasPlus,
    faArrowRight as fasArrowRight,
    faUser as fasUser,
    faLock as fasLock,
    faCircle as fasCircle,
    faKey as fasKey,
    faClock as fasClock,
    faTrash as fasTrash
} from '@fortawesome/pro-solid-svg-icons';

import {
    faBell as farBell,
    faUser as farUser,
    faBuilding as farBuilding,
    faPowerOff as farPowerOff,
    faHeart as farHeart,
    faSquare as farSquare,
    faBars as farBars
} from '@fortawesome/pro-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(fasHeart);
library.add(fasBell);
library.add(fasPlus);
library.add(fasCheck);
library.add(fasArrowRight);
library.add(fasCheckSquare);
library.add(fasLock);
library.add(farSquare);
library.add(farHeart);
library.add(farBell);
library.add(farUser);
library.add(fasUser);
library.add(farPowerOff);
library.add(farBuilding);
library.add(fasCircle);
library.add(fasKey);
library.add(fasClock);
library.add(fasTrash);
library.add(farBars);

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

import onesignal from './tools/onesignal';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {

        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .mixin({ methods: { route } } )
            .mixin(require('./tools/translate-mixin'))
            .mixin(require('./tools/debouncer'))
            .mixin(onesignal)
            .component('font-awesome-icon', FontAwesomeIcon )
            .mount(el);

    },
});

InertiaProgress.init({ color: '#4B5563' });
